import { FieldTitle } from '@components/FieldTitle/FieldTitle';
import { Input } from '@components/Input/Input';
import { Controller, useFormContext } from 'react-hook-form';
import { YStack } from 'tamagui';
import type { ReportFiltersField, ReportFiltersValues } from '../../reportFilters.types';

type TextFilterFieldConfig = Extract<ReportFiltersField, { type: 'text' }>;

interface TextFilterFieldProps {
  field: TextFilterFieldConfig;
}

export const TextFilterField = ({
  field,
}: TextFilterFieldProps): React.ReactElement => {
  const { control } = useFormContext<ReportFiltersValues>();

  return (
    <Controller
      control={control}
      name={field.id}
      render={({ field: controllerField }) => (
        <YStack gap="$2">
          <FieldTitle label={field.label} />
          <Input
            value={controllerField.value ?? ''}
            onChangeText={controllerField.onChange}
            placeholder={field.placeholder}
            autoCapitalize="none"
          />
        </YStack>
      )}
    />
  );
};
